export const enClientPortalAppraiserSelectionSection = {
    title: 'No appraiser assigned',
    description: 'Add at least one appraiser as an observer:',
    loading: 'Loading appraisers...',
    emptyState: 'No linked appraisers are available for this order.',
    fieldLabel: 'Appraiser',
}
